import jwt_decode from "jwt-decode";
import { useEffect, useState } from "react";

import LOCAL_STORAGE from "@/constants/local-storage";
import { IDecodedToken } from "@/interfaces/auth.interfaces";

const getAccessToken = (): string | null => {
  return localStorage ? localStorage.getItem(LOCAL_STORAGE.accessTokenKey) : null;
};

const useGetCustomerId = (): string | null => {
  const [customerId, setCustomerId] = useState<string | null>(null);

  useEffect(() => {
    // Obtém o token de acesso do Local Storage
    const accessToken = getAccessToken();

    if (accessToken) {
      // Decodifica o token para obter o CustomerId
      const decodedToken: IDecodedToken = jwt_decode(accessToken);
      const customer = decodedToken.CustomerId;
      setCustomerId(customer);
    }
  }, []);

  return customerId;
};

export default useGetCustomerId;
